import React from "react";
import { Link } from "react-router-dom";

export default function MarketingReports() {
  return (
    <div style={{ padding: "24px" }}>
      <h2>Marketing Reports</h2>
      <p>Select a report below:</p>
      <ul>
        <li>
          <Link to="/marketing-reports/campaigns-dashboard">Campaigns Dashboard</Link>
        </li>
        <li>
          <Link to="/marketing-reports/ad-performance-dashboards">Ad Performance Dashboards</Link>
        </li>
        <li>
          <Link to="/marketing-reports/store-level-monthly-report">Store Level - Monthly Report</Link>
        </li>
        <li>
          <Link to="/marketing-reports/division-level-monthly-report">Division Level - Monthly Report</Link>
        </li>
        <li>
          <Link to="/marketing-reports/ads-report">Google &amp; Meta Ads Report</Link>
        </li>
        <li>
          <Link to="/marketing-reports/meta-campaign-dashboard">Meta Campaign Dashboard</Link>
        </li>
        <li>
          <Link to="/marketing-reports/meta-mtd">Meta MTD Performance</Link>
        </li>
        <li>
          <Link to="/marketing-reports/consolidated-mtd">Consolidated MTD Performance</Link>
        </li>
        <li>
          <Link to="/marketing-reports/combined-performance">Paid Media Combined Performance</Link>
        </li>
      </ul>
    </div>
  );
}
